import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, EmailValidator, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Credentials } from '@bt/core';
import { TokenError } from '../login.interfaces';
import 'rxjs/add/operator/filter';

@Component({
    selector: 'login-form',
    styleUrls: ["./component.scss"],
    templateUrl: './component.html'
    // templateUrl: './component.old.html'
})
export class LoginFormComponent implements OnInit {
    @Input() public error: TokenError;
    @Input() public showLoader: boolean;
    @Output() public onLogin = new EventEmitter<Credentials>();
    @Output() public onClearError = new EventEmitter();

    private emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    public loginForm: FormGroup;
    public isSubmitted: boolean = false;
    constructor(private fb: FormBuilder) { }
   
    public ngOnInit() {
        this.loginForm = this.fb.group({
            email: ["", [Validators.required]],//Validators.pattern(this.emailPattern)
            password: new FormControl(null, Validators.required),
            agreement: new FormControl(false),

        });

        this.loginForm.valueChanges
            .filter(() => !!this.error)
            .forEach(() => {
                this.clearError();
            });
    }

    get email() { return this.loginForm.get('email'); }
    get password() { return this.loginForm.get('password'); }
    get agreement() { return this.loginForm.get('agreement'); }

    public login() {
        
        this.isSubmitted = true;
        if(!this.loginForm.valid && !this.loginForm.value.agreement)
            return;

        const credentials: Credentials = this.loginForm.value;
        this.onLogin.emit(credentials);
        
    }

    private clearError() {
        this.onClearError.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/public/login/form/component.ts